// Module
var code = `<div class="contact-us__status" role="status" aria-live="polite">
  <h2 class="contact-us__status-title"></h2>
  <p class="contact-us__status-msg"></p>
</div>

<div class="contact-us__form-holder">
  <h2>{{title}}</h2>

  <p class="contact-subtitle">{{subtitle}}</p>

  <form class="contact-us__form" data-event-prevent-default="true">
    {{#formFields}}
    <div class="contact-us__field">
      <label for="{{attrId}}">{{label}}</label>
      <input
        id="{{attrId}}"
        name="{{attrName}}"
        type="{{attrType}}"
        placeholder="{{attrPlaceholder}}"
        required="{{attrRequired}}"
      />
    </div>
    {{/formFields}}

    <div class="contact-us__field">
      <label for="contact-message">{{messageLabel}}</label>
      <textarea
        id="contact-message"
        name="message"
        rows="5"
        placeholder="{{attrMessagePlaceholder}}"
        required
      ></textarea>
    </div>

    <div class="contact-us__actions">
      <button class="btn btn-primary" type="submit">Send Message</button>
    </div>
  </form>
</div>
`;
// Exports
module.exports = code;